import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { feriasCalendarioApi } from '../api/feriasCalendarioApi'
import type { FeriasCalendarioParams, FeriasResumoParams } from '../types/feriasCalendario'

export const feriasCalendarioKeys = {
  all: ['ferias-controle'] as const,
  calendario: (params: FeriasCalendarioParams) =>
    [...feriasCalendarioKeys.all, 'calendario', params] as const,
  resumo: (params: FeriasResumoParams) => [...feriasCalendarioKeys.all, 'resumo', params] as const,
}

export function useFeriasCalendario(params: FeriasCalendarioParams) {
  return useQuery({
    queryKey: feriasCalendarioKeys.calendario(params),
    queryFn: () => feriasCalendarioApi.calendario(params),
    placeholderData: keepPreviousData,
  })
}

export function useFeriasResumo(params: FeriasResumoParams) {
  return useQuery({
    queryKey: feriasCalendarioKeys.resumo(params),
    queryFn: () => feriasCalendarioApi.resumo(params),
    placeholderData: keepPreviousData,
  })
}
